module.exports = __webpack_public_path__ + "img/legal_jl_img.ed93952b.png";